import { createSelector } from 'reselect';
//////////////////////////////////////////////////

const selectGlobalStore = (state) => state.global;
const selectPermissionsStore = (state) => state.permissions;

const makeSelectInitialDataLoadingStatus = () => createSelector(
  selectGlobalStore,
  (global) => global.initialDataLoading,
);

const makeSelectInitialDataLoadedStatus = () => createSelector(
  selectGlobalStore,
  (global) => global.initialDataLoaded,
);

const makeSelectAuthorities = () => createSelector(
  selectPermissionsStore,
  (permissionsState) => permissionsState.authorities,
);

const makeSelectPermissionsList = () => createSelector(
  selectPermissionsStore,
  (permissionsState) => permissionsState.permissionsList,
);

const makeSelectAccessToPagesList = () => createSelector(
  selectPermissionsStore,
  (permissionsState) => permissionsState.routesAccess,
);

export {
  makeSelectAuthorities,
  selectPermissionsStore,
  makeSelectPermissionsList,
  makeSelectAccessToPagesList,
  makeSelectInitialDataLoadedStatus,
  makeSelectInitialDataLoadingStatus,
};
